module.exports = __webpack_public_path__ + "static/media/akra_logo_black_red.31fa19cd.svg";